import { Autocomplete, AutocompleteChangeDetails, Button, Grid, TextField, Tooltip } from '@mui/material';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import BaseResponse from '../../app/BaseResponse';
import Utility from '../../app/utility';
import { resetCargoTypeInput, setInputExpand, setSelectedPortId, setSelectedPortIndex, setTriggerRefreshTable, setName, setCargoTypes, setCargoGroups, setCargoGroupName, setCargoTypesCache } from './reducers/CargoTypeManagementReducer';
import AreaModel from '../PortSelector/models/AreaModel';
import PortSelector from '../PortSelector/PortSelector';
import { portSelectorSelector } from '../PortSelector/reducers/PortSelectorReducer';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { cargoTypeManagerSelector } from './reducers/CargoTypeManagementReducer';
import CargoTypeSelectorApi from '../CargoTypeSelector/api/CargoTypeSelectorApi';
import CargoTypeModel from '../CargoTypeSelector/models/CargoTypeModel';

const CargoTypeManagementInput: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const cargoTypeManagementViewData = useSelector(cargoTypeManagerSelector);
    let portSelectorData = useSelector(portSelectorSelector);

    useEffect(() => {
        if (cargoTypeManagementViewData.triggerRefreshInput > 0) {
            refreshInput();
        }
    }, [cargoTypeManagementViewData.triggerRefreshInput]);

    const refreshInput = () => {
        dispatch(resetCargoTypeInput());
        dispatch(setSelectedPortId(-1));
        dispatch(setSelectedPortIndex(-1));
    }

    useEffect(() => {
        dispatch(showLoading(true));

        CargoTypeSelectorApi.GetCargoTypes()
            .then((response: BaseResponse<CargoTypeModel[]>) => {
                if (response.success) {
                    let cargoGroups: string[] = [];

                    _.each(response.data, (cargoType) => {
                        let selectedGroup = _.find(cargoGroups, (cargoGroup: string) => {
                            return cargoGroup === cargoType.cargoGroupName;
                        });

                        if (!selectedGroup && cargoType.cargoGroupName !== null) {
                            cargoGroups.push(cargoType.cargoGroupName);
                        }
                    });

                    dispatch(setCargoTypes(response.data));
                    dispatch(setCargoTypesCache(response.data));
                    dispatch(setCargoGroups(cargoGroups));
                } else {
                    Utility.Alert.Error(response.message);
                }
            })
            .catch((error) => {
                Utility.Alert.Error(error);
            }).finally(() => {
                dispatch(showLoading(false));
            })
    }, [cargoTypeManagementViewData.triggerRefreshTable]);

    const save = () => {
        try {
            validate();

            CargoTypeSelectorApi.SaveCargoType(cargoTypeManagementViewData.input)
                .then((response: BaseResponse<CargoTypeModel>) => {
                    if (response.success) {
                        if (cargoTypeManagementViewData.input.id == -1) {
                            Utility.Alert.Success("Cargo type added successful");
                        } else {
                            Utility.Alert.Success("Cargo type updated successful");
                        }

                        refreshInput();

                        dispatch(setTriggerRefreshTable(new Date().getTime()));
                    }
                    else {
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    Utility.Alert.Error(error);
                });
        } catch (error) {
            Utility.Alert.Error(error);
        }
    }

    const validate = () => {
        if (cargoTypeManagementViewData.input.name.length === 0) {
            throw "Name is required";
        }
    }

    return (
        <>
            <CustomAccordion
                title="Input"
                defaultOpen={true}
                className="top-quick-input"
                open={cargoTypeManagementViewData.inputExpand}
                onOpenChange={(isOpen: boolean) => {
                    dispatch(setInputExpand(isOpen));
                }}
            >
                <Grid container>
                    <Grid item lg={5} xs={12}
                        className='cargo-input-component'
                    >
                        <Grid container>
                            <Grid xs={10} lg={9}>
                                <TextField
                                    label="Name"
                                    fullWidth
                                    value={cargoTypeManagementViewData.input.name}
                                    onChange={(event) => {
                                        dispatch(setName(event.target.value.toUpperCase()));
                                    }}
                                    className="tonnage-input-full-tc"
                                />
                            </Grid>
                            <Grid item xs={2} lg={3}>
                                <Tooltip title="Reset">
                                    <Button
                                        className="clear-input-button"
                                        color="success"
                                        variant="contained"
                                        tabIndex={-1}
                                        onClick={() => {
                                            refreshInput();
                                        }}
                                    >
                                        <i className="fa fa-refresh" aria-hidden="true"></i>
                                    </Button>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item lg={5} xs={12}
                        className="cargo-input-component"
                    >
                        <Autocomplete
                            className='cargo-input-component'
                            options={cargoTypeManagementViewData.cargoGroups}
                            inputValue={cargoTypeManagementViewData.input.cargoGroupName ? cargoTypeManagementViewData.input.cargoGroupName : ""}
                            freeSolo={true}
                            renderInput={(params) => <TextField {...params} label="Cargo Group" />}
                            value={cargoTypeManagementViewData.input.cargoGroupName}
                            onChange={(event: React.SyntheticEvent, value: string | null, reason: string, details?: AutocompleteChangeDetails<string> | undefined) => {
                                dispatch(setCargoGroupName(value));
                            }}
                            onInputChange={(event: React.SyntheticEvent, value: string, reason: string) => {
                                dispatch(setCargoGroupName(value ? value.toUpperCase() : null));
                            }}
                        />
                    </Grid>
                    <Grid item lg={2} xs={12}
                    >
                        <Button
                            onClick={save}
                            variant="outlined"
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </CustomAccordion>
        </>
    )
};

export default CargoTypeManagementInput;